type Props = {
    data: any;
};

const OfferDetailsSummary = ({ data }: Props) => {
    return (
        <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md p-3">
            <div className="grid grid-cols-3 gap-6">
                <div>
                    <span className="block text-sm text-secondary">
                        Policy Number
                    </span>
                    <div className="mt-1 block w-full sm:text-sm text-primary">
                        {data?.policy_number || "N/A"}
                    </div>
                </div>
                <div className="col-span-2">
                    <span className="block text-sm text-secondary">Insured</span>
                    <div className="mt-1 block w-full sm:text-sm text-primary">
                        {data?.insured_by || "N/A"}
                    </div>
                </div>
                <div className="col-span-3">
                    <span className="block text-sm text-secondary">
                        Class of Business
                    </span>
                    <div className="mt-1 block w-full sm:text-sm text-primary">
                        {data?.class_of_business_id?.business_name || "N/A"}
                    </div>
                </div>
                <div>
                    <span className="block text-sm text-secondary">Premium</span>
                    <div className="mt-1 block w-full sm:text-sm text-primary">
                        {data?.premium || "N/A"}
                    </div>
                </div>
                <div>
                    <span className="block text-sm text-secondary">
                        Sum Insured
                    </span>
                    <div className="mt-1 block w-full sm:text-sm text-primary">
                        {data?.sum_insured || "N/A"}
                    </div>
                </div>
                <div>
                    <span className="block text-sm text-secondary">Currency</span>
                    <div className="mt-1 block w-full sm:text-sm text-primary">
                        {data?.currency || "N/A"}
                    </div>
                </div>
                <div>
                    <span className="block text-sm text-secondary">
                        Facultative Offer
                    </span>
                    <div className="mt-1 block w-full sm:text-sm text-primary">
                        {data?.facultative_offer || "N/A"}
                    </div>
                </div>
                <div>
                    <span className="block text-sm text-secondary">
                        Commission
                    </span>
                    <div className="mt-1 block w-full sm:text-sm text-primary">
                        {data?.commission || "N/A"}
                    </div>
                </div>
                <div>
                    <span className="block text-sm text-secondary">Brokerage</span>
                    <div className="mt-1 block w-full sm:text-sm text-primary">
                        {data?.brokerage || "N/A"}
                    </div>
                </div>
                <div>
                    <span className="block text-sm text-secondary">
                        Period From
                    </span>
                    <div className="mt-1 block w-full sm:text-sm text-primary">
                        {data?.period_of_insurance_from || "N/A"}
                    </div>
                </div>
                <div>
                    <span className="block text-sm text-secondary">
                        Period To
                    </span>
                    <div className="mt-1 block w-full sm:text-sm text-primary">
                        {data?.period_of_insurance_to || "N/A"}
                    </div>
                </div>
                {data?.risk_location && (
                    <div>
                        <span className="block text-sm text-secondary">
                            Risk Location
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {data.risk_location}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default OfferDetailsSummary;
